module.exports = __webpack_public_path__ + "img/tab-background-right.66e7b258.svg";